import { KibButtonNew } from '@chewy/kib-controls-react'
import { KibSpinner } from '@chewy/kib-interstitials-react'
import { KibContainer } from '@chewy/kib-layout-react'

import '@chewy/kib-interstitials-styles/dist/styles/kib-spinner.css'
import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import '@chewy/kib-layout-styles/dist/styles/kib-container.css'
import styles from './PaymentControls.module.scss'

interface PaymentControlsProps {
  cancelButton?: boolean
  disabled?: boolean
  emphasis?: 'primary' | 'secondary'
  isLoading?: boolean
  primaryAction: () => void
  primaryText?: string
}

export const PaymentControls = ({
  isLoading = false,
  primaryAction,
  primaryText,
  emphasis,
  disabled,
  cancelButton,
}: PaymentControlsProps) => (
  <KibContainer
    className={cancelButton ? styles.containerCancelButton : styles.container}
  >
    <KibButtonNew
      disabled={disabled}
      emphasis={emphasis}
      icon={isLoading && <KibSpinner />}
      loading={isLoading}
      size="large"
      theme="action"
      onClick={primaryAction}
    >
      {primaryText}
    </KibButtonNew>
  </KibContainer>
)
